import { useEffect } from 'react'

import { useStoreLayouts, useStorePartials, useStoreTemplates, useThemeTypes } from '@/modules/cms/views/post/components/builder/context'
import useAutoSelectEditing from '@/modules/cms/views/post/components/builder/hooks/useAutoSelectEditing'

import Empty from './Empty'
import Types from './Types'

export default function Pages() {
  const { list } = useThemeTypes()
  const { handleLoad: handleLoadTemplates } = useStoreTemplates()
  const { handleLoad: handleLoadLayouts } = useStoreLayouts()
  const { handleLoad: handleLoadPartials } = useStorePartials()

  useEffect(() => {
    handleLoadTemplates()
  }, [handleLoadTemplates])

  useEffect(() => {
    handleLoadLayouts()
  }, [handleLoadLayouts])

  useEffect(() => {
    handleLoadPartials()
  }, [handleLoadPartials])

  useAutoSelectEditing()

  if (!list) return null

  return <>
    {list?.length ? <>
      <Types />
    </> : <>
      <Empty />
    </>}
  </>
}

